<template>
  <div class="modal hide fade in" id="modalCambios" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" >Modificación de Evaluación</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="form-group col-6">
              <label class="text-success"></label>
                <select id="catalogoDeTipos" class="form-control" @change="cambiarTipo($event, true)">
                  <option value= 0>Seleccione tipo</option>
                  <option v-for="opcion in tipoElementos" :key="opcion.tipoId" :value="opcion.tipoId" >{{opcion.NombreTipo}}</option>
                </select>
            </div>
          </div>
          <div class="row" v-if="parametros_TipoElemento.tipoElementoId==1">
              <div class="form-group col-7">
                <label>Evaluado Actual</label>
                <input type="text" class="form-control" v-model="CambioEvaluacion.NombreActual" readonly/>
              </div>
              <div class="form-group col-4">
                <label>No. Nomina Evaluado que remplaza</label>
                <input type="number" class="form-control" v-model="parametros_Peticion.Nomina"/>
              </div>
              <div class="form-group col-1 d-flex align-items-end">
                <button type="button" class="btn btn-sm btn-warning" title="Verificar Numero de Nomina" @click="verificarPersona()"><i class="fas fa-search"></i></button>
              </div>
          </div>
          <div class="row" v-if="parametros_TipoElemento.tipoElementoId==1 && infoPersona.PersonaId>0">
            <div class="form-group col-6">
              <label>Nombre</label>
              <input type="text" class="form-control" v-model="infoPersona.NombreCompleto" readonly/>
            </div>
            <div class="form-group col-6">
              <label>Departamento</label>
              <input type="text" class="form-control" v-model="infoPersona.Departamento" readonly/>
            </div>
          </div>
          <div class="row" v-if="parametros_TipoElemento.tipoElementoId==1 && infoPersona.PersonaId>0">
            <div class="form-group col-6">
              <label>Área</label>
              <input type="text" class="form-control" v-model="infoPersona.Seccion" readonly/>
            </div>
          </div>
          <div class="row" v-if="parametros_TipoElemento.tipoElementoId==2">
            <div class="form-group col-7">
              <label>Evaluador desempeño Actual</label>
              <input type="text" class="form-control" v-model="CambioEvaluacion.NombreActual" readonly/>
            </div>
            <div class="form-group col-4">
              <label>No. Nomina Evaluador sustituto</label>
              <input type="number" class="form-control" v-model="parametros_Peticion.Nomina"/>
            </div>
            <div class="form-group col-1 d-flex align-items-end">
              <button type="button" class="btn btn-sm btn-warning" title="Verificar Numero de Nomina" @click="verificarPersona()"><i class="fas fa-search"></i></button>
            </div>
          </div>
          <div class="row" v-if="parametros_TipoElemento.tipoElementoId==2 && infoPersona.PersonaId>0">
            <div class="form-group col-6">
              <label>Nombre</label>
              <input type="text" class="form-control" v-model="infoPersona.NombreCompleto" readonly/>
            </div>
            <div class="form-group col-6">
              <label>Departamento</label>
              <input type="text" class="form-control" v-model="infoPersona.Departamento" readonly/>
            </div>
          </div>
          <div class="row" v-if="parametros_TipoElemento.tipoElementoId==2 && infoPersona.PersonaId>0">
            <div class="form-group col-6">
              <label>Área</label>
              <input type="text" class="form-control" v-model="infoPersona.Seccion" readonly/>
            </div>
          </div>
          <div class="row" v-if="parametros_TipoElemento.tipoElementoId==3">
            <div class="form-group col-7">
              <label class="text-success">Evaluadores</label>
                <select id="catalogoDeEvaluadores" class="form-control" @change="cambiarElemento($event)">
                  <option value= 0>Seleccione Evaluador de Actitud</option>
                  <option v-for="opcion in EvaluadoresActitud" :key="opcion.idCuestionario" :value="opcion.idCuestionario" >{{opcion.Evaluador.NombreCompleto}}</option>
                </select>
            </div>
            <div class="form-group col-4" v-if="parametros_Evaluador.tipoElementoId>0">
              <label>No. Nomina Evaluador sustituto</label>
              <input type="number" class="form-control" v-model="parametros_Peticion.Nomina"/>
            </div>
            <div class="form-group col-1 d-flex align-items-end" v-if="parametros_Evaluador.tipoElementoId>0" >
              <button type="button" class="btn btn-sm btn-warning" title="Verificar Numero de Nomina" @click="verificarPersona()"><i class="fas fa-search"></i></button>
            </div>
          </div>
          <div v-if="MostrarNoexiste==false">
            <div class="row" v-if="parametros_TipoElemento.tipoElementoId==3 && infoPersona.PersonaId>0">
              <div class="form-group col-6">
                <label>Nombre</label>
                <input type="text" class="form-control" v-model="infoPersona.NombreCompleto" readonly/>
              </div>
              <div class="form-group col-6">
                <label>Departamento</label>
                <input type="text" class="form-control" v-model="infoPersona.Departamento" readonly/>
              </div>
            </div>
            <div class="row" v-if="parametros_TipoElemento.tipoElementoId==3 && infoPersona.PersonaId>0">
              <div class="form-group col-6">
                <label>Área</label>
                <input type="text" class="form-control" v-model="infoPersona.Seccion" readonly/>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="row">
              <div class="form-group col-12 text-center">
                <label class="text-danger">Verifique No. de Nómina</label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-secondary" id="botonCancelar" >Cancelar</button>
          <button type="button" class="btn btn-sm btn-success" id="botonAceptar">Confirmar</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'


  export default {
    props: {
        Evaluacion: Object,
        AreaEvaluacion : {type : String, default : ""}
    },
    data() {
      return {
        CambioEvaluacion : {
          NombreActual: "",
          EvaluacionId: 0,
          CuestionarioId: 0
        },
        EvaluadoresActitud : [],
        tipoElementos :[
          {tipoId: 1, NombreTipo: "Evaluado"},
          {tipoId: 2, NombreTipo: "Evaluador Desempeño"},
          {tipoId: 3, NombreTipo: "Evaluador Actitud"}],
        parametros_TipoElemento: {
          tipoElementoId: 0
        },
        parametros_Evaluador: {
          tipoElementoId: 0
        },
        parametros_Peticion : {
          Nomina: null
        },
        infoPersona : {},
        MostrarNoexiste : false
      }
    },
    methods: {
        Mostrar: function () {
            $('#modalCambios').modal('show');
            $('#botonCancelar').unbind('click').click(this.ModalClose);
            $('#closeModal').unbind('click').click(this.ModalClose);
            $('#botonAceptar').unbind('click').click(this.Modificar);
            },
        ModalClose: function(Editado = false){
            let nombre = this.AreaEvaluacion
            $('#modalCambios').modal('hide');
            this.$emit('dialogo', {'Estatus': false, 'Editado': Editado, "NombreArea": nombre});
        },
        Modificar: function(){
          if(this.ValidaDatos()==true)
          {
            let peticion = {
              "EvaluacionId": this.CambioEvaluacion.EvaluacionId,
              "CuestionarioId" : this.CambioEvaluacion.CuestionarioId,
              "infoPersona" : this.infoPersona
            }
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.SISEVA.funcion.CambiarEvaluacionEstimulo, peticion,comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)).then(response => {
              if (response.data.SiHayError == false) {
                comun.SeEstaCargandoInformacion(false);
                this.ModalClose(true)
              }
              else {
                this.ModalClose(true)
                console.error(response);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
              }
            }).catch(e => {
              console.error("encontre un error "+e);
              comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
            });
          }
          
        },
        cambiarTipo(datos, tipo){
          this.parametros_Peticion.Nomina=null;
          this.infoPersona = {}
            this.parametros_TipoElemento.tipoElementoId = parseInt(datos.target.value);
            
            this.CambioEvaluacion = {
              NombreActual: "",
              PersonaId: 0,
              EvaluacionId: 0,
              CuestionarioId: 0
            }
            switch (this.parametros_TipoElemento.tipoElementoId)
            {
              case 1: 
                this.CambioEvaluacion.EvaluacionId = this.Evaluacion.EvaluacionId;
                this.CambioEvaluacion.NombreActual = this.Evaluacion.nombreEvaluado
                break;
              case 2:
                var objeto = this.Evaluacion.evaluadores.find(b=>b.FormatoCuestionarioId ==17);
                this.CambioEvaluacion.CuestionarioId = objeto.idCuestionario;
                this.CambioEvaluacion.EvaluacionId = this.Evaluacion.EvaluacionId;
                this.CambioEvaluacion.NombreActual = objeto.Evaluador.NombreCompleto;
                
                break;
              case 3:
                var objeto = this.Evaluacion.evaluadores.find(b=>b.FormatoCuestionarioId ==17);
                var lista = this.Evaluacion.evaluadores.filter(b=>b.FormatoCuestionarioId ==18 && b.EvaluadorId!=objeto.EvaluadorId);
                this.EvaluadoresActitud = lista;
                break;
            }
            
        },
        cambiarElemento(datos){
          this.parametros_Evaluador.tipoElementoId = parseInt(datos.target.value);
          this.CambioEvaluacion.CuestionarioId = this.parametros_Evaluador.tipoElementoId;
          this.CambioEvaluacion.EvaluacionId = this.Evaluacion.EvaluacionId;
        },
        verificarPersona(){
          if(this.parametros_Peticion.Nomina>0 && this.parametros_Peticion.Nomina!=null)
          {
            var numNomina = this.parametros_Peticion.Nomina;
            let peticion = {
              "esPrueba": false,
              "nombreBusqueda" : '',
              "numeroNominaBusqueda": parseInt(numNomina,10),
              "baneados": []};
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.SIAP.funcion.GetPersonas, peticion,comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)).then(response => {
            if (response.data.SiHayError == false) {
              if(response.data.InfoPersonas.length>0)
              {
                this.infoPersona= response.data.InfoPersonas[0];
                this.MostrarNoexiste = false;
              }
              else
              {
                this.infoPersona = {}
                this.MostrarNoexiste =true;
              }
            }
            else {
              console.error(response);
              comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
            }
            comun.SeEstaCargandoInformacion(false);
            }).catch(e => {
              console.error("encontre un error "+e);
              comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
            });
          }
          else
          {
            comun.mensajeDeAlerta("Determine el Numero de Nómina del Evaluador sustituto", null, null);
          }
        },
        ValidaDatos(){
          if(this.CambioEvaluacion.EvaluacionId==0)
          {
            comun.mensajeDeAlerta("Seleccione un tipo de elemento en la Evaluación", null, null);
            return false;
          };
          if(this.parametros_Peticion.Nomina==0 || this.parametros_Peticion.Nomina==null || this.MostrarNoexiste==true)
          {
            comun.mensajeDeAlerta("Ingrese Numero de Nomina y verifique", null, null);
            return false;
          }
          if(this.infoPersona.PersonaId==0 || this.infoPersona.PersonaId==undefined || this.MostrarNoexiste==true)
          {
            comun.mensajeDeAlerta("Verifique Numero de Nomina", null, null);
            return false;
          }
          return true;
        }
        
    },
    mounted(){
        this.Mostrar()
    }
  }
</script>
<style scoped>
input[type="text"]:read-only {
    background: #504f54;
}

input[type="text"]:read-only:focus {
      color: #fff;
}
.modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    display: none; 
    overflow: hidden;
    outline: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/SISEVA/Comun/modalCambiosEvaluacion.vue